import { SecuredKoppClient } from 'Core/Api/Kopp/SecuredKoppClient';
import { GetTrackedBolDetailsByIdCommandRequest } from 'Core/Api/Kopp/Api';

export class TrackedBolDetailViewHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  GetTrackedBolById(request: GetTrackedBolDetailsByIdCommandRequest) {
    const client = new SecuredKoppClient();

    client.showLoading = true;
    client.handleSecurityError = false;
    client.handleGeneralError = false;
    return client.getTrackedBolDetailsById(request)
  }

}
